import { styled } from "@mui/material/styles";
import { Banner, Button, Lede, Logo, Meta, PageTitle } from "@UI";
import React from "react";
import { useTranslation } from "react-i18next";
const Root = styled("div")({
    flex: 1,
    display: "flex",
    flexDirection: "column",
    padding: "var(--j-sp-6) var(--j-sp-4)",
    "& > .signin-hero": {
        flex: 1,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        gap: "var(--j-sp-2)"
    },
    "& .signin-brand": {
        display: "flex",
        color: "var(--j-ink)"
    },
    "& .signin-hero p": {
        lineHeight: "var(--j-lh-lg)"
    },
    "& > .signin-actions": {
        display: "flex",
        flexDirection: "column",
        gap: "var(--j-sp-2)"
    },
    "& .signin-hint": {
        display: "block",
        textAlign: "center"
    }
});
export function SignIn({ isSigningIn, reason, onSignIn }) {
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(Root, null, /*#__PURE__*/ React.createElement("div", {
        className: "signin-hero"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "signin-brand"
    }, /*#__PURE__*/ React.createElement(Logo, {
        height: 24
    })), /*#__PURE__*/ React.createElement(PageTitle, {
        size: "md",
        title: t("shell.signIn.title")
    }), /*#__PURE__*/ React.createElement(Lede, null, t("shell.signIn.text"))), /*#__PURE__*/ React.createElement("div", {
        className: "signin-actions"
    }, reason && !isSigningIn && /*#__PURE__*/ React.createElement(Banner, {
        tone: "warn"
    }, t(`shell.signedOut.${reason}`)), /*#__PURE__*/ React.createElement(Button, {
        size: "lg",
        loading: isSigningIn,
        onClick: onSignIn
    }, isSigningIn ? t("shell.signIn.signingIn") : t("shell.signIn.button")), /*#__PURE__*/ React.createElement(Meta, {
        className: "signin-hint"
    }, t("shell.signIn.hint"))));
}
